// extracted by mini-css-extract-plugin
export var csatScore = "_lq-5";
export var header = "_lq-1";
export var panelWrapper = "_lq-2";
export var postPreview = "_lq-3";
export var rightContent = "_lq-0";
export var wrappingText = "_lq-4";